// src/pages/Projects.js
import React from "react";
import projectData from "../data/projects.json";

function ProjectCard({ title, description, tools, link, isApp }) {
  return (
    <div
      className="bg-white border-2 border-orange-950 p-6
                 shadow-[6px_6px_0px_0px_rgba(0,0,0,1)]
                 transition-all duration-300
                 hover:scale-[1.02] hover:shadow-[10px_10px_0px_0px_rgba(0,0,0,1)]
                 flex flex-col justify-between h-full"
    >
      <div>
        <h2 className="text-lg font-bold mb-3 uppercase leading-tight">
          {title}
        </h2>
        <div className="flex flex-wrap gap-2 mb-4">
          {tools.map((tool) => (
            <span
              key={tool}
              className="text-[10px] bg-orange-100 border border-orange-950 px-2 py-0.5 font-bold uppercase"
            >
              {tool}
            </span>
          ))}
        </div>
        <p className="text-xs mb-8 leading-relaxed opacity-90">{description}</p>
      </div>

      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="block w-full text-center bg-orange-950 text-white py-3 px-4
                   font-bold uppercase tracking-widest
                   hover:bg-orange-800 transition-colors text-xs"
      >
        {isApp ? "View Project" : "View Repo"}
      </a>
    </div>
  );
}

function Projects() {
  return (
    <div className="relative min-h-screen bg-transparent font-mono text-orange-950">
      <div className="flex flex-col items-center justify-start pt-24 pb-60 px-6 mx-auto w-full">
        <h1 className="text-[clamp(1.5rem,4vw,2.5rem)] font-bold mb-12 border-b-4 border-orange-950 pb-2 text-center">
          Projects
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl w-full">
          {projectData.map((project) => (
            <ProjectCard key={project.id} {...project} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Projects;